import { render } from "./relesedata.vue?vue&type=template&id=19f9fa4e"
import script from "./relesedata.vue?vue&type=script&lang=js"
export * from "./relesedata.vue?vue&type=script&lang=js"

import "./relesedata.vue?vue&type=style&index=0&id=19f9fa4e&lang=css"

import exportComponent from "D:\\work\\work\\project\\intelegent\\ips\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__